import * as CompanyTypes from './company.types';
import moment from 'moment';
import {
  IgetCompanyInfoAPIResponseData,
  IupdateCompanyImageAPIResponseData,
  TSocialMedia,
} from 'api/endpoints/company/company.response.interface';
import { ICompanyUpdateFields, IInitialCompanyState } from 'interfaces/company.interface';
import { IgetClientsAPIResponseDataItem } from 'api/endpoints/superAdmin/superAdmin.response.interface';

export type TcompanyDispatchReducer =
  | {
      type: typeof CompanyTypes.GET_COMPANY_DATA;
      payload: {
        company: IgetCompanyInfoAPIResponseData;
      };
    }
  | {
      type: typeof CompanyTypes.GET_COMPANY_DATA_SUPER_ADMIN;
      payload: {
        company: IgetClientsAPIResponseDataItem;
        client_social_media: TSocialMedia[];
      };
    }
  | {
      type: typeof CompanyTypes.UPDATE_COMPANY;
      payload: ICompanyUpdateFields;
    }
  | {
      type: typeof CompanyTypes.UPDATE_COMPANY_LOGO;
      payload: IupdateCompanyImageAPIResponseData;
    }
  | {
      type: typeof CompanyTypes.ADD_SOCIAL_MEDIA;
      payload: TSocialMedia;
    }
  | {
      type: typeof CompanyTypes.SET_SOCIAL_MEDIA;
      payload: TSocialMedia[];
    }
  | {
      type: typeof CompanyTypes.SET_IS_LOADING;
      payload: boolean;
    };

export default function companyReducer(
  state: IInitialCompanyState,
  action: TcompanyDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case CompanyTypes.GET_COMPANY_DATA: {
      const loginUser: IInitialCompanyState = {
        ...state,
        company: {
          ...payload.company,
          logo: payload?.company?.logo
            ? `${payload?.company?.logo}?ts=${moment().unix()}`
            : '',
        },
      };
      return loginUser;
    }

    case CompanyTypes.GET_COMPANY_DATA_SUPER_ADMIN: {
      const loginCompanySuperAdmin: IInitialCompanyState = {
        ...state,
        company: {
          ...payload.company,
          telephone_prefix: payload.company.tel_prefix,
          telephone_sufix: payload.company.tel_sufix,
          logo: payload.company.logo
            ? `${payload.company.logo}?ts=${moment().unix()}`
            : '',
          client_social_media: payload.client_social_media,
          gln: payload.company.gln || null,
          tarif_clients: payload.company.tarif_clients || null,
        },
      };
      return loginCompanySuperAdmin;
    }

    case CompanyTypes.UPDATE_COMPANY: {
      const {
        name,
        legal_name,
        country_id,
        country_name,
        province,
        city,
        address,
        postal_code,
        email,
        tel_prefix,
        tel_sufix,
        cif,
        floor,
        door,
        lat,
        lng,
        contact_name,
        web,
        instagram,
        youtube,
        linkedin,
        facebook,
        gln,
      } = payload;
      const updateCompany: IInitialCompanyState = {
        ...state,
        company: {
          ...(state.company as IgetCompanyInfoAPIResponseData),
          name,
          legal_name,
          country: {
            id: country_id,
            name: country_name,
          },
          province,
          city,
          address,
          postal_code,
          email,
          telephone_prefix: tel_prefix,
          telephone_sufix: tel_sufix,
          cif,
          floor,
          door,
          lat,
          lng,
          contact_name,
          web,
          instagram,
          youtube,
          linkedin,
          facebook,
          gln,
        },
      };
      return updateCompany;
    }

    case CompanyTypes.UPDATE_COMPANY_LOGO: {
      const updateCompanyLogo: IInitialCompanyState = {
        ...state,
        company: {
          ...(state.company as IgetCompanyInfoAPIResponseData),
          logo: `${payload.url}?ts=${moment().unix()}`,
        },
      };
      return updateCompanyLogo;
    }

    case CompanyTypes.ADD_SOCIAL_MEDIA: {
      const addSocialMedia: IInitialCompanyState = {
        ...state,
        company: {
          ...(state.company as IgetCompanyInfoAPIResponseData),
          client_social_media: [
            ...(state.company as IgetCompanyInfoAPIResponseData).client_social_media,
            payload,
          ],
        },
      };
      return addSocialMedia;
    }

    case CompanyTypes.SET_SOCIAL_MEDIA: {
      const setSocialMedia: IInitialCompanyState = {
        ...state,
        company: {
          ...(state.company as IgetCompanyInfoAPIResponseData),
          client_social_media: payload,
        },
      };
      return setSocialMedia;
    }

    case CompanyTypes.SET_IS_LOADING: {
      const setIsLoading: IInitialCompanyState = {
        ...state,
        isLoading: payload,
      };
      return setIsLoading;
    }

    default:
      return state;
  }
}
